var render = function (_h,_vm) {var _c=_vm._c;return _c('i',{staticClass:"fa",class:[_vm.props.value === null ? 'fa-question' : _vm.props.value ? 'fa-check' : 'fa-close']})}
var staticRenderFns = []

export { render, staticRenderFns }